// extracted by mini-css-extract-plugin
module.exports = {"ShadowBoxContainer":"ShadowBox_ShadowBoxContainer__2udFM"};